import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './navbox.scss';
import { __ } from '@wordpress/i18n';

const pluginUrl = nxtext_ajax_object?.nxtex_url || '';
const adminUrl = nxtext_ajax_object?.adminUrl || '';

const NavBox = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [extraOptionsOpen, setExtraOptionsOpen] = useState(false);
    const [extensionsOpen, setExtensionsOpen] = useState(false);
    const [menuToggle, setMenuToggle] = useState(false);

    const brandName = nxtext_ajax_object?.dashData?.whiteLabelData?.brandname;
    const brandLogo = nxtext_ajax_object?.dashData?.whiteLabelData?.brandlogo;

    // Memoized check for active path
    const isActive = useCallback(
        (path) => location.pathname === path,
        [location.pathname]
    );

    // Toggle Extra Options
    const toggleExtraOptions = useCallback(() => {
        setExtraOptionsOpen((prev) => !prev);
    }, []);
    // Toggle Extensions
    const toggleExtensionsOpen = useCallback(() => {
        setExtensionsOpen((prev) => !prev);
    }, []);

    // Handle WordPress "Theme Builder" redirect
    const handleThemeBuilderClick = useCallback(() => {
        window.location.href = nxtext_ajax_object.themebuilderStatus == '1' || nxtext_ajax_object.themebuilderStatus == undefined ? `${adminUrl}admin.php?page=nxt_builder` : `${adminUrl}edit.php?post_type=nxt_builder`;
    }, []);

    const handleCodeSnippetsClick = useCallback(() => {
        window.location.href = `${adminUrl}admin.php?page=nxt_code_snippets`;
    }, []);

    // Expand dropdown if pathname matches
    useEffect(() => {
        const openPaths = [
            '/rollback_plugin',
            '/whitelabel',
            '/more_products',
            '/import-export',
            '/asset-delivery',
            '/custom-css-js',
            '/blocks-settings',
            '/ai-compatibility'
        ];
        setExtraOptionsOpen(openPaths.some((p) => location.pathname.startsWith(p)));
    }, [location.pathname]);

    // Expand dropdown if pathname matches
    useEffect(() => {
        const openPaths = [
            '/utilities',
            '/performance',
            '/security',
            '/admin_interface',
        ];
        setExtensionsOpen(openPaths.some((p) => location.pathname.startsWith(p)));
    }, [location.pathname]);

    // Memoized Pro/Free state
    const isPro =  (nxtext_ajax_object.pro || nxtext_ajax_object.tpgb_pro);
    const whiteLabel = useMemo(
        () => nxtext_ajax_object?.dashData?.whiteLabel || {},
        []
    );
    const keyStatus = useMemo(
        () => nxtext_ajax_object?.dashData?.keyActmsg?.status || nxtext_ajax_object?.dashData?.tpgb_keyActmsg?.status,
        []
      );

    return (
        <div className="nxtext_navigation_cover">
            {/* Logo Strip */}
            <div className="nxtext_logo_strip">
                <span className="nxtext_logo_wrap">
                    {brandLogo && (
                        <img
                            className="nxtext_main_logo"
                            src={brandLogo}
                            draggable={false}
                            alt="Brand Logo"
                        />
                    )}
                    {/* <span className="nxtext_thex_title">{brandName}</span> */}
                </span>

                {/* Mobile Menu */}
                <div className="nxtext-mobile-menu">
                    <div className="nxtext_hint_text">
                        {isPro ? (
                            <>
                                <img
                                    className="nxtext_pro_icon"
                                    src={`${pluginUrl}assets/svg/premium_icon.svg`}
                                    draggable={false}
                                    alt="Pro Icon"
                                />{' '}
                                {__('Pro', 'nexter-extension')}
                            </>
                        ) : (
                            __('Free', 'nexter-extension')
                        )}
                    </div>
                    <svg
                        className="nxtext-menu-btn"
                        onClick={() => setMenuToggle((prev) => !prev)}
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                    >
                        <path
                            d="M4 16H28M4 8H28M4 24H28"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
            </div>

            {/* Navigation */}
            <div
                className={`nxtext_navlinks_cover ${menuToggle ? 'tpae_open_menu' : ''}`}
            >
                <div className="nxtext_navlinks_inner_cover">
                    <div>
                        <Link
                            className={`nxtext_navlink ${isActive('/') ? 'nxtext_active_tab' : ''}`}
                            to="/"
                        >
                            {__('Welcome', 'nexter-extension')}
                        </Link>
                    </div>
                    { !((nxtext_ajax_object.pro || nxtext_ajax_object.tpgb_pro) && nxtext_ajax_object?.dashData?.whiteLabel?.nxt_template_tab == 'on') &&
                        <div>
                            <Link
                                className={`nxtext_navlink ${isActive('/templates') ? 'nxtext_active_tab' : ''}`}
                                to="/templates"
                            >
                                {__('WordPress Templates', 'nexter-extension')}
                            </Link>
                        </div>
                    }
                    <div>
                        <Link
                            className={`nxtext_navlink ${isActive('/blocks') ? 'nxtext_active_tab' : ''}`}
                            to="/blocks"
                        >
                            {__('Blocks', 'nexter-extension')}
                        </Link>
                    </div>
                    <div>
                        <span
                            className="nxtext_navlink"
                            onClick={handleThemeBuilderClick}
                            style={{ cursor: 'pointer' }}
                        >
                            {__('Theme Builder', 'nexter-extension')}
                        </span>
                    </div>
                    <div>
                        { nxtext_ajax_object?.dashData?.extensioninstall == true ?
                            <Link
                                className={`nxtext_navlink ${isActive('/code_snippets') ? 'nxtext_active_tab' : ''}`}
                                to="/code_snippets"
                                >
                                {__('Code Snippets', 'nexter-extension')}
                            </Link>
                            :
                            <span  className="nxtext_navlink" onClick={handleCodeSnippetsClick} style={{ cursor: 'pointer' }} > {__('Code Snippets', 'nexter-extension')}</span>
                        }
                    </div>
                    {/* Extensions */}
                    <div>
                        <span
                            className={`nxtext_navlink ${isActive('/extensions') ? 'nxtext_active_tab' : ''}`}
                            onClick={toggleExtensionsOpen}
                        >
                            {__('Extensions', 'nexter-extension')}
                            <span
                                className={`nxtext_navlink_icon ${extensionsOpen ? 'nxtext-icon-down' : ''}`}
                            >
                                <img
                                    src={`${pluginUrl}assets/svg/chevron_right_icon.svg`}
                                    draggable={false}
                                    alt="Arrow Icon"
                                />
                            </span>
                        </span>
                    </div>
                    {extensionsOpen && (
                        <div className="nxtext_extra_options_inner_tabs">
                            <div className="nxtext_nav_dropdown_links">
                                <Link
                                    className={`nxtext_navlink ${isActive('/utilities') ? 'nxtext_active_tab' : ''}`}
                                    to="/utilities"
                                >
                                    {__('Utilities', 'nexter-extension')}
                                </Link>
                            </div>
                            <div className="nxtext_nav_dropdown_links">
                                <Link
                                    className={`nxtext_navlink ${isActive('/performance') ? 'nxtext_active_tab' : ''}`}
                                    to="/performance"
                                >
                                    {__('Performance', 'nexter-extension')}
                                </Link>
                            </div>
                            <div className="nxtext_nav_dropdown_links">
                                <Link
                                    className={`nxtext_navlink ${isActive('/security') ? 'nxtext_active_tab' : ''}`}
                                    to="/security"
                                >
                                    {__('Security', 'nexter-extension')}
                                </Link>
                            </div>
                            <div className="nxtext_nav_dropdown_links">
                                <Link
                                    className={`nxtext_navlink ${isActive('/admin_interface') ? 'nxtext_active_tab' : ''}`}
                                    to="/admin_interface"
                                >
                                    {__('Admin Interface', 'nexter-extension')}
                                </Link>
                            </div>
                        </div>
                    )}
                    <div>
                        <Link
                            className={`nxtext_navlink ${isActive('/theme_customizer') ? 'nxtext_active_tab' : ''}`}
                            to="/theme_customizer"
                        >
                            {__('Theme Customizer', 'nexter-extension')}
                        </Link>
                    </div>
                    {/* Extra Options */}
                    <div>
                        <span
                            className={`nxtext_navlink ${isActive('/extra_options') ? 'nxtext_active_tab' : ''}`}
                            onClick={toggleExtraOptions}
                        >
                            {__('Extra Options', 'nexter-extension')}
                            <span
                                className={`nxtext_navlink_icon ${extraOptionsOpen ? 'nxtext-icon-down' : ''}`}
                            >
                                <img
                                    src={`${pluginUrl}assets/svg/chevron_right_icon.svg`}
                                    draggable={false}
                                    alt="Arrow Icon"
                                />
                            </span>
                        </span>
                    </div>

                    {extraOptionsOpen && (
                        <div className="nxtext_extra_options_inner_tabs">
                            {nxtext_ajax_object?.dashData?.tpgbinstall &&
                                <>
                                    <div className="nxtext_nav_dropdown_links">
                                        <Link
                                            className={`nxtext_navlink ${isActive('/blocks-settings') ? 'nxtext_active_tab' : ''}`}
                                            to="/blocks-settings"
                                        >
                                            {__('Settings', 'nexter-extension')}
                                        </Link>
                                    </div>
                                    <div className="nxtext_nav_dropdown_links">
                                        <Link
                                            className={`nxtext_navlink ${isActive('/asset-delivery') ? 'nxtext_active_tab' : ''}`}
                                            to="/asset-delivery"
                                        >
                                            {__('Asset Delivery', 'nexter-extension')}
                                        </Link>
                                    </div>
                                    <div className="nxtext_nav_dropdown_links">
                                        <Link
                                            className={`nxtext_navlink ${isActive('/custom-css-js') ? 'nxtext_active_tab' : ''}`}
                                            to="/custom-css-js"
                                        >
                                            {__('Custom CSS & JS', 'nexter-extension')}
                                        </Link>
                                    </div>
                                    <div className="nxtext_nav_dropdown_links">
                                        <Link
                                            className={`nxtext_navlink ${isActive('/ai-compatibility') ? 'nxtext_active_tab' : ''}`}
                                            to="/ai-compatibility"
                                        >
                                            {__('AI Integration', 'the-plus-addons-for-block-editor')}
                                        </Link>
                                    </div>
                                </>
                            }
                            {((nxtext_ajax_object?.dashData?.tpgbinstall || nxtext_ajax_object?.dashData?.extensioninstall) && !((nxtext_ajax_object.pro || nxtext_ajax_object.tpgb_pro) && whiteLabel?.nxt_rollback_tab == 'on')) && (
                                <div className="nxtext_nav_dropdown_links">
                                    <Link
                                        className={`nxtext_navlink ${isActive('/rollback_plugin') ? 'nxtext_active_tab' : ''}`}
                                        to="/rollback_plugin"
                                    >
                                        {__('Roll Back Plugin', 'nexter-extension')}
                                    </Link>
                                </div>
                            )}
                            {((nxtext_ajax_object?.dashData?.tpgbinstall || nxtext_ajax_object?.dashData?.extensioninstall) && (whiteLabel === false || whiteLabel?.nxt_hidden_label !== 'on' || whiteLabel?.tpgb_hidden_label !== 'on')) && (
                                <div className="nxtext_nav_dropdown_links">
                                    <Link
                                        className={`nxtext_navlink ${isActive('/whitelabel') ? 'nxtext_active_tab' : ''}`}
                                        to="/whitelabel"
                                    >
                                        {__('White Label', 'nexter-extension')}
                                    </Link>
                                </div>
                            )}
                            { ( nxtext_ajax_object?.dashData?.extensioninstall ) &&
                                <div className="nxtext_nav_dropdown_links">
                                    <Link
                                        className={`nxtext_navlink ${isActive('/import-export') ? 'nxtext_active_tab' : ''}`}
                                        to="/import-export"
                                    >
                                        {__('Import/Export', 'nexter-extension')}
                                    </Link>
                                </div>
                            }

                            { !((nxtext_ajax_object.pro || nxtext_ajax_object.tpgb_pro)  && whiteLabel?.nxt_plugin_ads == 'on') && (
                                <div className="nxtext_nav_dropdown_links">
                                    <Link
                                        className={`nxtext_navlink ${isActive('/more_products') ? 'nxtext_active_tab' : ''}`}
                                        to="/more_products"
                                    >
                                        {__('More Products', 'nexter-extension')}
                                    </Link>
                                </div>
                            )}
                        </div>
                    )}

                    {/* Pro / Free */}
                    <div>
                        {isPro ? (
                            whiteLabel?.nxt_licence_tab !== 'on' && (
                                <Link
                                    className={`nxtext_navlink ${isActive('/activate_PRO') ? 'nxtext_active_tab' : ''}`}
                                    to="/activate_PRO"
                                >
                                    {keyStatus === 'valid' ? (
                                        <>
                                            {__('Activated', 'nexter-extension')}
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="14"
                                                height="14"
                                                fill="none"
                                                viewBox="0 0 11 12"
                                            >
                                                <path
                                                    fill="#14C38E"
                                                    d="M5.086.778c-.798.076-1.404.245-2.067.579A5.698 5.698 0 0 0 .806 3.386C.421 4 .141 4.794.027 5.589a8.373 8.373 0 0 0 0 1.354c.09.634.259 1.189.52 1.72a5.094 5.094 0 0 0 1.063 1.485c.476.473.887.767 1.465 1.051a4.82 4.82 0 0 0 1.075.398 5.461 5.461 0 0 0 3.205-.153 6.67 6.67 0 0 0 1.162-.582 5.857 5.857 0 0 0 1.654-1.694c.154-.243.404-.759.505-1.045a5.452 5.452 0 0 0-.247-4.284 5.265 5.265 0 0 0-.985-1.393 5.25 5.25 0 0 0-1.53-1.113A5.264 5.264 0 0 0 5.98.785a7.327 7.327 0 0 0-.893-.007Z"
                                                />
                                                <path
                                                    fill="#fff"
                                                    d="M7.604 4.47c-.029.012-.759.73-1.621 1.597L4.41 7.64l-.585-.587c-.632-.632-.637-.634-.82-.598a.363.363 0 0 0-.244.245c-.035.187-.047.173.753.975.8.803.784.79.973.755.07-.012.273-.208 1.806-1.743 1.254-1.258 1.731-1.748 1.748-1.8a.34.34 0 0 0-.13-.383.413.413 0 0 0-.308-.035Z"
                                                />
                                            </svg>
                                        </>
                                    ) : (
                                        __('Activate PRO', 'nexter-extension')
                                    )}
                                </Link>
                            )
                        ) : (
                            <a target="_blank" rel="noopener noreferrer" href='https://nexterwp.com/pricing/?utm_source=wpbackend&utm_medium=blocks&utm_campaign=nextersettings'
                            className={`nxtext_navlink`} >
                                {__('Upgrade Now', 'nexter-extension')}
                                <span className="nxtext_navlink_icon">
                                    <img
                                        src={`${pluginUrl}assets/svg/premium_icon.svg`}
                                        draggable={false}
                                        alt="Premium Icon"
                                    />
                                </span>
                            </a>
                        )}
                    </div>
                </div>

                {/* Footer */}
                <div className="nxtext_version_and_system_info">
                    {whiteLabel?.brandname && (
                        <>
                            <p className="nxtext_version">
                                {__('Version ', 'nexter-extension') +
                                    nxtext_ajax_object.dashData.pluginVer}
                            </p>{' '}
                            |{' '}
                            <a
                                target="_blank"
                                rel="nofollow noopener noreferrer"
                                href={`${adminUrl}site-health.php?tab=debug`}
                                className="nxtext_system_info"
                            >
                                {__('System Info', 'nexter-extension')}
                            </a>
                        </>
                    )}
                </div>
            </div>
            <div className="nxtext_content_area"></div>
        </div>
    );
};

export default React.memo(NavBox);
